import React from 'react';
import SEO from '../SEO/SEO';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import NewsletterSignup from '../NewsletterSignup/NewsletterSignup';
import '../Styles/reset.css';
import '../Styles/utils.css';
import '../Styles/layout.css';

function PrivacyPolicy() {
    return (
        <div>
            <SEO
                title="Privacy Policy - Smart Life Choice"
                description="Learn how Smart Life Choice collects, uses, and protects your personal information. Read our comprehensive privacy policy."
                url="/privacy-policy"
                keywords="privacy policy, data protection, GDPR, user privacy, personal information"
            />
            <Header />

            <main className="main">
                <div className="container">
                    <section className="policy-section" style={{
                        maxWidth: '900px',
                        margin: '0 auto',
                        padding: '2rem 1rem'
                    }}>
                        <h1 style={{
                            fontSize: '2.5rem',
                            fontWeight: '700',
                            marginBottom: '1rem',
                            color: 'var(--color-primary)'
                        }}>Privacy Policy</h1>

                        <div style={{
                            fontSize: '0.95rem',
                            color: 'var(--color-gray-600)',
                            marginBottom: '2rem',
                            paddingBottom: '1rem',
                            borderBottom: '2px solid var(--color-gray-200)'
                        }}>
                            <p><strong>Effective Date:</strong> 10 November 2025</p>
                            <p><strong>Last Updated:</strong> 10 November 2025</p>
                        </div>

                        <div style={{
                            lineHeight: '1.8',
                            fontSize: '1.05rem',
                            color: 'var(--color-gray-800)'
                        }}>
                            <h2 style={{
                                fontSize: '1.75rem',
                                fontWeight: '600',
                                marginTop: '2.5rem',
                                marginBottom: '1rem',
                                color: 'var(--color-gray-900)'
                            }}>1. Introduction</h2>
                            <p style={{ marginBottom: '1.5rem' }}>
                                Welcome to Smart Life Choice ("we", "our", or "us"). Your privacy is important to us.
                                This Privacy Policy explains how we collect, use, and protect your personal information
                                when you visit <a href="https://smartlifechoice.co.uk" style={{
                                    color: 'var(--color-primary)',
                                    textDecoration: 'underline'
                                }}>https://smartlifechoice.co.uk</a>.
                            </p>
                            <p style={{ marginBottom: '1.5rem' }}>
                                By using our website, you agree to this Privacy Policy.
                            </p>

                            <h2 style={{
                                fontSize: '1.75rem',
                                fontWeight: '600',
                                marginTop: '2.5rem',
                                marginBottom: '1rem',
                                color: 'var(--color-gray-900)'
                            }}>2. Information We Collect</h2>
                            <p style={{ marginBottom: '1rem' }}>
                                We may collect and process the following types of data:
                            </p>
                            <ul style={{
                                marginLeft: '2rem',
                                marginBottom: '1.5rem',
                                listStyle: 'disc'
                            }}>
                                <li style={{ marginBottom: '0.75rem' }}>
                                    <strong>Personal Information:</strong> Your name, email address, or any details you
                                    voluntarily provide through forms, comments, or newsletter sign-ups.
                                </li>
                                <li style={{ marginBottom: '0.75rem' }}>
                                    <strong>Usage Data:</strong> Information such as your IP address, browser type, device
                                    information, pages visited, and time spent on the site (via Google Analytics).
                                </li>
                                <li style={{ marginBottom: '0.75rem' }}>
                                    <strong>Cookies:</strong> Small text files stored on your device that help improve your
                                    browsing experience and measure traffic.
                                </li>
                            </ul>

                            <h2 style={{
                                fontSize: '1.75rem',
                                fontWeight: '600',
                                marginTop: '2.5rem',
                                marginBottom: '1rem',
                                color: 'var(--color-gray-900)'
                            }}>3. How We Use Your Information</h2>
                            <p style={{ marginBottom: '1rem' }}>
                                We may use your data to:
                            </p>
                            <ul style={{
                                marginLeft: '2rem',
                                marginBottom: '1.5rem',
                                listStyle: 'disc'
                            }}>
                                <li style={{ marginBottom: '0.75rem' }}>Improve our website and tailor content to your interests</li>
                                <li style={{ marginBottom: '0.75rem' }}>Send you newsletters or updates (only with your consent)</li>
                                <li style={{ marginBottom: '0.75rem' }}>Analyse visitor trends via Google Analytics</li>
                                <li style={{ marginBottom: '0.75rem' }}>Display relevant ads or affiliate links</li>
                                <li style={{ marginBottom: '0.75rem' }}>Respond to your queries or comments</li>
                            </ul>
                            <p style={{ marginBottom: '1.5rem' }}>
                                We do not sell, rent, or trade your information with others.
                            </p>

                            <h2 style={{
                                fontSize: '1.75rem',
                                fontWeight: '600',
                                marginTop: '2.5rem',
                                marginBottom: '1rem',
                                color: 'var(--color-gray-900)'
                            }}>4. Third-Party Services</h2>
                            <p style={{ marginBottom: '1rem' }}>
                                We use trusted third-party services such as:
                            </p>
                            <ul style={{
                                marginLeft: '2rem',
                                marginBottom: '1.5rem',
                                listStyle: 'disc'
                            }}>
                                <li style={{ marginBottom: '0.75rem' }}>Google Analytics (website traffic analysis)</li>
                                <li style={{ marginBottom: '0.75rem' }}>Google AdSense (advertising and monetization)</li>
                                <li style={{ marginBottom: '0.75rem' }}>Affiliate Networks (such as Amazon Associates, if applicable)</li>
                            </ul>
                            <p style={{ marginBottom: '1.5rem' }}>
                                These services may use cookies or tracking technologies in accordance with their own privacy policies.
                            </p>

                            <h2 style={{
                                fontSize: '1.75rem',
                                fontWeight: '600',
                                marginTop: '2.5rem',
                                marginBottom: '1rem',
                                color: 'var(--color-gray-900)'
                            }}>5. Data Protection and Security</h2>
                            <p style={{ marginBottom: '1.5rem' }}>
                                We implement reasonable technical and administrative measures to protect your personal information.
                                However, no online system can guarantee complete security.
                            </p>

                            <h2 style={{
                                fontSize: '1.75rem',
                                fontWeight: '600',
                                marginTop: '2.5rem',
                                marginBottom: '1rem',
                                color: 'var(--color-gray-900)'
                            }}>6. Your Rights (UK GDPR)</h2>
                            <p style={{ marginBottom: '1rem' }}>
                                You have the right to:
                            </p>
                            <ul style={{
                                marginLeft: '2rem',
                                marginBottom: '1.5rem',
                                listStyle: 'disc'
                            }}>
                                <li style={{ marginBottom: '0.75rem' }}>Request access to your personal data</li>
                                <li style={{ marginBottom: '0.75rem' }}>Request correction or deletion of your information</li>
                                <li style={{ marginBottom: '0.75rem' }}>Withdraw consent to marketing at any time</li>
                            </ul>
                            <p style={{ marginBottom: '1.5rem' }}>
                                To exercise these rights, contact us at:{' '}
                                <a href="mailto:smartlifechoiceuk@gmail.com" style={{
                                    color: 'var(--color-primary)',
                                    textDecoration: 'underline'
                                }}>smartlifechoiceuk@gmail.com</a>
                            </p>

                            <h2 style={{
                                fontSize: '1.75rem',
                                fontWeight: '600',
                                marginTop: '2.5rem',
                                marginBottom: '1rem',
                                color: 'var(--color-gray-900)'
                            }}>7. Changes to This Policy</h2>
                            <p style={{ marginBottom: '1.5rem' }}>
                                We may update this Privacy Policy occasionally. The latest version will always be available on this page.
                            </p>

                            <h2 style={{
                                fontSize: '1.75rem',
                                fontWeight: '600',
                                marginTop: '2.5rem',
                                marginBottom: '1rem',
                                color: 'var(--color-gray-900)'
                            }}>8. Contact Us</h2>
                            <p style={{ marginBottom: '1.5rem' }}>
                                If you have any questions, please email us at:{' '}
                                <a href="mailto:smartlifechoiceuk@gmail.com" style={{
                                    color: 'var(--color-primary)',
                                    textDecoration: 'underline'
                                }}>smartlifechoiceuk@gmail.com</a>
                            </p>
                        </div>
                    </section>
                </div>

                <NewsletterSignup />
            </main>

            <Footer />
        </div>
    );
}

export default PrivacyPolicy;
